import React, { useEffect, useRef } from 'react';
import { Modal, Button } from '@/ui';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Styles the confirm button red. Use for irreversible destructive actions. */
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  onConfirm,
  onCancel,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  // Focus the cancel button when the dialog opens so accidental Enter doesn't confirm
  useEffect(() => {
    if (isOpen) cancelRef.current?.focus();
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      title={title}
      size="sm"
      showClose={false}
      footer={
        <>
          <Button ref={cancelRef} variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant={destructive ? 'destructive' : 'primary'}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-body-md text-ink-muted leading-relaxed">{message}</p>
    </Modal>
  );
};

export default ConfirmDialog;
